import './Contact.css';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function Contact() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
        event.preventDefault();

        const myForm = event.target;
        const myFormData = new FormData(myForm);

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(myFormData).toString(),
        })
            .then(() => navigate("/contact/thank-you/"))
            .catch((error) => alert(error));
    };

  return (
    <div className="container">
      <Navbar/>
      <div className="mainContent">
        <div className="contentBoxLeft">
            <h2>Let's get in touch!</h2>
      <form
        className="contact-form"
        name="contact"
        method="POST"
        data-netlify="true"
        action="/contact/thank-you"
        onSubmit={handleSubmit}
      >
        {/* Hidden input for Netlify to detect the form */}
        <input type="hidden" name="form-name" value="contact" />

        <p>
          <label>
            Your Name:
            <input
              type="text"
              name="name"
              autoComplete="on"
              className="short-input"
              onChange={handleChange}
              value={formData.name}
            />
          </label>
        </p>
        <p>
          <label>
            Your Email:
            <input
              type="email"
              name="email"
              autoComplete="on"
              className="short-input"
              onChange={handleChange}
              value={formData.email}
            />
          </label>
        </p>
        <p>
          <label>
            Subject:{" "}
            <input
              type="text"
              name="subject"
              className="long-input"
              onChange={handleChange}
              value={formData.subject}
            />
          </label>
        </p>
        <p>
          <label>
            Message:{" "}
            <textarea
              name="message"
              className="long-input"
              onChange={handleChange}
              value={formData.message}
            ></textarea>
          </label>
        </p>
        <p>
          <button type="submit">Submit</button>
        </p>
      </form>
        </div>
      </div>
      <Sidebar/>
    </div>
  );
}